// newsListHelper.tsx
import React, { JSX, ReactNode } from 'react';

// Helper function to process footnote references
export const processFootnotes = (text: string): ReactNode[] => {
    if (!text) return [text];

    const segments = text.split(/(\[\^?\d+\](?:\[\^?\d+\])*)/g);

    return segments.map((segment, index) => {
        if (!segment) return null;

        if (segment.match(/^\[\^?\d+\]/)) {
            const numbers = Array.from(segment.matchAll(/\[\^?(\d+)\]/g)).map(match => match[1]);
            if (numbers.length === 0) return segment;

            return (
                <React.Fragment key={index}>
                    {numbers.map((num, i) => (
                        <sup key={`${index}-${i}`} className="text-xs font-medium text-gray-600 ml-0.5">
                            {num}
                        </sup>
                    ))}
                </React.Fragment>
            );
        }

        return segment;
    }).filter(Boolean);
};

// Helper function to get translated category names
export const getTranslatedType = (type: string, t: any): string => {
    if (t?.navigations?.header?.[type.toLowerCase()]) {
        return t.navigations.header[type.toLowerCase()];
    }
    return type;
};


// Helper function to get translated meta Description, keywordss
export const getTranslatedMetaInfo = (type: string, t: any): string => {
    if (t?.navigations?.[type.toLowerCase()]) {
        return t.navigations[type.toLowerCase()];
    }
    return type;
};

// Archive button click handler factory
export const handleArchiveClick = (
    getUrlLanguagePrefix: (lang: string) => string,
    language: string,
    finalType: string,
    finalSubtype: string | undefined,
    navigate: (path: string) => void
): void => {
    const prefix = getUrlLanguagePrefix(language);
    let path = `${prefix}/news/archive`;

    const queryParams = new URLSearchParams();
    if (finalType) queryParams.append('type', finalType);
    if (finalSubtype) queryParams.append('subtype', finalSubtype);

    if (queryParams.toString()) {
        path += `?${queryParams.toString()}`;
    }
 
     
    if (finalType.toLowerCase() !== 'trending') {
        navigate(`${prefix}/news/archive/category/${finalType.toLowerCase()}`);
      } else {
        navigate(`${prefix}/news/archive/`);
      }
  
    // navigate(path);
};

// Row click handler generator
export const generateRowClickHandler = (
    itemId: number,
    getUrlLanguagePrefix: (lang: string) => string,
    language: string,
    navigate: (path: string) => void
): (() => void) => {
    return () => {
        const prefix = getUrlLanguagePrefix(language);
        navigate(`${prefix}/news/${itemId}`);
    };
};
